/**
 * dev-utils.ts — Development utilities
 */
export function isDevelopment() {
    if (typeof window === "undefined")
        return false;
    // Check for localhost or development domains
    const hostname = window.location.hostname;
    return (hostname === "localhost" ||
        hostname === "127.0.0.1" ||
        hostname.startsWith("192.168.") ||
        hostname.startsWith("10.") ||
        hostname.endsWith(".local") ||
        hostname.includes("dev.") ||
        hostname.includes("staging."));
}
export function devLog(module, ...args) {
    if (isDevelopment()) {
        console.debug(`[${module}]`, ...args);
    }
}
export function devError(module, ...args) {
    // Always log errors, even in production
    console.error(`[${module}]`, ...args);
}
export function devWarn(module, ...args) {
    if (isDevelopment()) {
        console.warn(`[${module}]`, ...args);
    }
}
//# sourceMappingURL=dev-utils.js.map